// Components
import { Flex, Text } from 'yard-utilities/components'

interface ListItemProps {
  icon?: React.ReactNode
  children: React.ReactNode
  position?: 'center' | 'flex-start' | 'baseline' | 'flex-end'
  contentPosition?: 'center' | 'flex-start'
  textSize?: string
  textColor?: string
  fontWeight?: 400 | 500 | 600 | 700
  gap?: number[]
  className?: string
  iconOffset?: number
}

const ListItem = ({
  icon,
  children,
  position = 'center',
  contentPosition = 'flex-start',
  textColor = 'black',
  textSize = 'body-5',
  gap = [16],
  fontWeight = 700,
  iconOffset = 0,
  className
}: ListItemProps) => {
  return (
    <Flex
      alignItems={position}
      justifyContent={contentPosition}
      columnGap={{ sm: gap[0], lg: gap[1] || gap[0] }}
      className={className}
    >
      <div style={{ marginTop: `${iconOffset}px` }}>{icon}</div>
      <Text
        tagName="p"
        textColor={textColor}
        variant={textSize}
        fontWeight={fontWeight}
      >
        {children}
      </Text>
    </Flex>
  )
}

export default ListItem
